import { PRODUCT_LISTING_SET_PROP, ProductListingType, PRODUCT_LISTING_RECEIVE, PRODUCT_LISTING_LOADING } from '../constants';

const DEFUALT_STATE = {
  products: [],
  facetFilters: [],
  totalProducts: null,
  productListingType: null,
  productListing: null,
  loading: false,
};

export const productListing = (state = DEFUALT_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_LISTING_SET_PROP:
      // Expects payload: { prop, value }
      console.log("Setting product listing property:", payload);
      if (!payload || typeof payload.prop !== 'string') {
        return state;
      }
      return {
        ...state,
        [payload.prop]: payload.value,
      };
      case PRODUCT_LISTING_RECEIVE:
        return {
          ...state,
          ...payload,
          loading: false,
        };
      case PRODUCT_LISTING_LOADING:
        return {
          ...state,
          loading: payload,
        };
    default:
      return state;
  }
};
